// Persisted in the `color` field — renaming a value orphans every document holding it.
export enum ColorId {
  ScarletFlame = 'scarlet-flame',
  StrawberrySorbet = 'strawberry-sorbet',
  BlushPink = 'blush-pink',
  CitrusEmber = 'citrus-ember',
  SunsetCoral = 'sunset-coral',
  ToastedPeach = 'toasted-peach',
  GoldenMarigold = 'golden-marigold',
  SunshineGold = 'sunshine-gold',
  HoneyGlow = 'honey-glow',
  VerdantLeaf = 'verdant-leaf',
  HerbalSage = 'herbal-sage',
  FrostedMint = 'frosted-mint',
  OceanTeal = 'ocean-teal',
  SeafoamMist = 'seafoam-mist',
  MintWhisper = 'mint-whisper',
  ElectricSapphire = 'electric-sapphire',
  AzureWave = 'azure-wave',
  CeruleanBreeze = 'cerulean-breeze',
  RoyalAmethyst = 'royal-amethyst',
  VividPeriwinkle = 'vivid-periwinkle',
  CoolSky = 'cool-sky',
  FuchsiaRose = 'fuchsia-rose',
  CottonCandy = 'cotton-candy',
  PetalPink = 'petal-pink',
  MidnightIndigo = 'midnight-indigo',
  DuskyLavender = 'dusky-lavender',
  LavenderMist = 'lavender-mist',
  CinnamonOak = 'cinnamon-oak',
  AutumnTaupe = 'autumn-taupe',
  VintageSand = 'vintage-sand',
  DeepCharcoal = 'deep-charcoal',
  SteelGray = 'steel-gray',
  SilveryCloud = 'silvery-cloud',
}
